import { Button, Col, DatePicker, PageHeader, Row } from "antd";

import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";

import { Link, useHistory, useParams } from "react-router-dom";
import { fetchMasterFileStatusList, setBlurModal } from "../../core/store/reducers/settings.slice";
import { RootState } from "../../shared/constants";
import TableLayout from "../../shared/layouts/table.layout";
import { allTableConfigs } from "./components/config";
import UploadFileComponent from "./components/upload-file.component";
import { fetchTicketsList } from "../../core/store/reducers/tickets.slice";
import { getFilesByCategory, getFilesCategories } from "../../core/store/reducers/files.slice";
import moment from "moment";
import { ROUTE_FILE_CONFIGURATION, ROUTE_FILE_LIST_CONFIGURATION } from "../../core/route/ui.routes";
import { debounce } from "../../shared/utilities";
const { RangePicker } = DatePicker;

function FilesListPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const params: any = useParams();
  const { master_file_status } = useSelector((state: RootState) => state.settings);
  const { loading_files, pagination } = useSelector(
    (state: RootState) => state.files
  );
  const [uploadFileVisible, setUploadFileVisible] = useState(false as any);
  const [listData, setListData] = useState([] as any);

  // Actions and selections
  const [formElements, setFormElements] = useState(null as any);
  const [columns, setColumns] = useState([] as any);
  // const [statusList, setStatusList] = useState([] as any);
  const [filters, setFilters] = useState({} as any);

  const screenType = {
    desktop: useMediaQuery({ minWidth: 992 }),
    tablet: useMediaQuery({ minWidth: 768, maxWidth: 991 }),
    mobile: useMediaQuery({ maxWidth: 767 }),
  };
  useEffect(() => {
    columns?.length > 0 && formElements &&
      loadList();
  }, [columns, formElements]);
  useEffect(() => {
    Object.keys(filters)?.length > 0 &&
      loadList();
  }, [filters]);
  useEffect(() => {
    master_file_status?.length == 0 && dispatch(fetchMasterFileStatusList({}))
  }, []);
  useEffect(() => {
    if (params?.category_id) {
      console.log(allTableConfigs)
      setColumns(allTableConfigs["file-list"].columns(params?.category_name));
      setFormElements({
        onFinish: () => {},
        onFinishFailed: () => {},
        onValuesChange: debounce(filterFormSubmit, 700),
        initialValues: { ...filters },
        filtersApplied: filters
          ? Object.keys(
              Object.fromEntries(
                Object.entries(filters).filter(([_, v]) => v != null)
              )
            ).length
          : 0,
        setValues: {
          ...filters,
        },
        formElements: allTableConfigs["file-list"].filterForm(master_file_status),
      });
    }
  }, [params,master_file_status]);

  const loadList = (offset: number = 0) => {
    let filter = {};
    if (filters?.range?.length == 2) {
      filter = { ...filter, 
        from_date: moment(filters.range[0]).format('YYYY-MM-DD'),
        to_date: moment(filters.range[1]).format('YYYY-MM-DD')
      };
    }
    if (filters?.search) {
      filter = { ...filter, search_term: filters?.search };
    }
    if (filters?.status) {
      filter = { ...filter, status_id: filters?.status };
    }
    dispatch(
      getFilesByCategory({
        category_id: params?.category_id,
        params:{
          ...(pagination?.offset && pagination?.limit ? pagination : {offset: 0, limit: 10}),
          offset: offset,
          ...filter,
        }
      })
    ).then((val:any)=>{
      if(val?.payload?.data?.data?.items){
        setListData(val?.payload?.data?.data?.items?.map((val:any, index:any)=>{
          return {...val, sno: index + 1 + offset}
        }))
      }
    });

  };
  async function filterFormSubmit(changed: any, all: any) {
    setFilters(all);
  }

  // console.log(formElements);
  const onPageChange = (e: any, pageSize: any) => {
    let offset = (e - 1) * pagination.limit;
    loadList(offset);
  };
  useEffect(() => {
    dispatch(setBlurModal(uploadFileVisible));
  }, [uploadFileVisible]);

  return (
    <Fragment>
      <PageHeader
        ghost={false}
        title={
          <Row
            style={screenType.mobile ? { paddingLeft: "25px" } : {}}
            align="middle"
            gutter={8}
          >
            <Col className="title-text"><span style={{cursor: 'pointer', paddingLeft: '5px', paddingRight: '5px'}} onClick={()=>history.push(ROUTE_FILE_CONFIGURATION)}>&lt;</span></Col>
            <Col className="title-text">{params?.category_name}</Col>
          </Row>
        }
        extra={
          <Row align="middle">
            <Col className="title-text">
              <Button
                key="1"
                onClick={() => {
                  setUploadFileVisible(true);
                }}
                className="ant-btn-hover"
              >
                Upload File
              </Button>
            </Col>
          </Row>
        }
      ></PageHeader>

      <Row className="content-area pt-4">
        <Col span={24}>
          {columns && formElements && (
            <TableLayout
              defaultCurrentPage={pagination.offset / pagination.limit + 1}
              loading={loading_files}
              buttonEvt={() => {}}
              dataSource={listData}
              filters="multiple"
              columns={columns}
              onChange={(e, ee) => onPageChange(e, ee)}
              type="morefilters"
              total={pagination.total}
              showTotal={true}
              pagination={{
                position: ["none", "none"],
                pageSize: pagination.limit,
              }}
              paginationPosition="top"
              formData={formElements}
              maxWidth={1000}
              defaultPageSize={10}
              showSizeChangerFlag={false}
            />
          )}
        </Col>
      </Row>
      {uploadFileVisible && (
        <UploadFileComponent
          formVisible={uploadFileVisible}
          setFormVisible={setUploadFileVisible}
          reloadList={loadList}
        />
      )}
    </Fragment>
  );
}

export default FilesListPage;
